import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import CustomSelectNew from "../../../components/UpdateUi/CustomeSelect";
import ToastModal from "views/components/ToastModal";
import { riskCategoryList } from "assets/properties/properties";
import { actions } from "assets/properties/properties";
const RiskCategoryScoreMasterCreate = ({ props, classes }) => {
  const navigate = useNavigate();
  const params = useParams();
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [minAuditedLtv, setMinAuditedLtv] = useState("");
  const [minAuditedLtvState, setMinAuditedLtvState] = useState(false);
  const [maxAuditedLtv, setMaxAuditedLtv] = useState("");
  const [maxAuditedLtvState, setMaxAuditedLtvState] = useState(false);
  const [riskCategory, setRiskCategory] = useState("");
  const [riskCategoryState, setRiskCategoryState] = useState("");
  const viewPage = window.location.href.includes("createView");
  const [riskCategoryData,setRiskCategoryData]= useState([]);
  const [disableButton,setDisabledButton]=useState(false);
  useEffect(()=>{
    findRiskCategoryData();
  },[])
  const findRiskCategoryData = async () => {
    const result = await apiHandler({
      url: endpoint.RISK_CATEGORY_AND_SCORE_DATA,
      authToken: authToken,
    });
    if(result?.data?.loanRiskCategoryScores?.length  > 0){
      setRiskCategoryData(result?.data?.loanRiskCategoryScores);
    }
  }

  useEffect(() => {
    (async () => {
      if (params?.id) {
        setCallInProgress(true);
        try {
          // Get Data from API
          const result = await apiHandler({
            url: endpoint.RISK_CATEGORY_SCORE_FIND_ALL,
            authToken: authToken,
          });
          if (result?.data?.length) {
            const item = result?.data?.find((item) => Number(item?.id) === Number(params?.id));
            if (item) {
              setRiskCategory(item?.riskCategory || "");
              setMinAuditedLtv(Number(item?.minAuditLtvScore) || 0);
              setMaxAuditedLtv(Number(item?.maxAuditLtvScore) || 0);
            }
          }
        } finally {
          setCallInProgress(false);
        }
      }
    })();
  }, []);  

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const editInformation = async () => {
    if (isValidated()) {
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.RISK_CATEGORY_SCORE_UPDATE + params?.id,
        method: "PUT",
        authToken: authToken,
        data: {
          riskCategory: riskCategory,
          minAuditLtvScore: minAuditedLtv,
          maxAuditLtvScore: maxAuditedLtv,
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return actions.error;
      } else {
        return actions.success;
      }
    }
  };
  const isValidated = () => {
    const fields = [
      { value: riskCategory, setter: setRiskCategoryState },
      { value: maxAuditedLtv, setter: setMaxAuditedLtvState },
      { value: minAuditedLtv, setter: setMinAuditedLtvState },
    ];

    let isValid = true;

    fields.forEach(({ value, setter }) => {
      if (value === "") {
        setter(true);
        isValid = false;
      } else {
        setter(false);
      }
    });

    if (Number(maxAuditedLtv) < Number(minAuditedLtv)) {
      toastUpdate(
        "Error",
        `Max Audit LTV Score should be greater than ${minAuditedLtv}`,
        true
      );
      return false;
    }

    return isValid;
  };

  const saveInformation = async () => {
    if (isValidated()) {
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.RISK_CATEGORY_SCORE_CREATE,
        method: "POST",
        authToken: authToken,
        data: {
          riskCategory: riskCategory,
          minAuditLtvScore: minAuditedLtv,
          maxAuditLtvScore: maxAuditedLtv,
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return actions.error;
      } else {
        return actions.success;
      }
    }
  };
  const handleDiscrepancySubmit = async (event) => {
    toastUpdate("", "", false);
    let status = "";
    if (params?.id) {
      status = await editInformation();
    } else {
      status = await saveInformation();
    }
    if (status === actions.success) {
      const message = params?.id
        ? "Risk Category Score updated successfully!"
        : "Risk Category Score created successfully!";
      toastUpdate("Success", message, true);
      setRedirectURL(`/coreservice/riskCategoryTab`);
    }
  };
  const handleCancel = () => {
    navigate("/coreservice/riskCategoryTab");
  };

  const title = viewPage ? "View Risk Category Score" : "Edit Risk Category Score";

  const handleMinAuditedLtv = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex?.test(e)) {
      setMinAuditedLtv(e);
    }
  };
  const handleMaxAuditedLtv = (e) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex?.test(e)) {
      setMaxAuditedLtv(e);
    }
  };
  const handleBlur = async (e, name) => {
    const value = Number(e);
    if(riskCategoryData?.length < 1){
      if (name === "minAudited" && value >= Number(maxAuditedLtv)) {
        toastUpdate("Error", `Min Audited LTV Score can't be greater than (${maxAuditedLtv})`, true);
        setDisabledButton(true);
        return;
      }
      if (name === "maxAudited" && value <= Number(minAuditedLtv)) {
        toastUpdate("Error", `Max Audited LTV Score can't be smaller than (${minAuditedLtv})`, true);
        setDisabledButton(true);
        return;
      }
    }
    if ((name === "minAudited" || name === "maxAudited") && value > 100) {
      toastUpdate("Error", `Value can't be greater than 100`, true);
      setDisabledButton(true);
      return;
    }
  
    let filteredData = [];
    if (params?.id) {
      filteredData = riskCategoryData?.filter((item) => item?.id !== Number(params?.id));
    } else {
      filteredData = riskCategoryData;
    }
    // Compare with riskCategoryData using a for loop
    for (let i = 0; i < filteredData.length; i++) {
      const item = filteredData[i];
  
      if (name === "minAudited" && value <= Number(item?.maxAuditLtvScore)) {
        toastUpdate("Error", `Min Audited LTV Score can't be smaller than (${item?.maxAuditLtvScore})`, true);
        setDisabledButton(true);
        return;
      }
      if (name === "minAudited" && value >= Number(maxAuditedLtv)) {
        toastUpdate("Error", `Min Audited LTV Score can't be greater than (${maxAuditedLtv})`, true);
        setDisabledButton(true);
        return;
      }
      
      if (name === "maxAudited" && value <= Number(item?.maxAuditLtvScore)) {
        toastUpdate("Error", `Max Audited LTV Score should be greater than (${item?.maxAuditLtvScore})`, true);
        setDisabledButton(true);
        return;
      }
      if (name === "maxAudited" && value <= Number(minAuditedLtv)) {
        toastUpdate("Error", `Max Audited LTV Score can't be smaller than (${minAuditedLtv})`, true);
        setDisabledButton(true);
        return;
      }
    }
    setDisabledButton(false);
  };
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={params?.id ? title : "Create Risk Category Score"}
          button1={!viewPage && "Save"}
          button2=" Cancel"
          button1click={!viewPage && handleDiscrepancySubmit}
          button2click={handleCancel}
          disabled1={disableButton}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Risk Category*"
              error={riskCategoryState}
              id="riskCategory"
              value={riskCategory?.toUpperCase()}
              setState={setRiskCategory}
              data={riskCategoryList}
              setError={setRiskCategoryState}
              type="packetNumbers"
              disabled={viewPage}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Min Audited Ltv Score(Max 100)"
              required
              id="minAuditedLtv"
              value={minAuditedLtv}
              setState={handleMinAuditedLtv}
              error={minAuditedLtvState}
              setError={setMinAuditedLtvState}
              disabled={viewPage}
              setBlur={(e) => handleBlur(e, 'minAudited')}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Max Audited Ltv Score(Max 100)"
              required
              id="maxAuditedLtv"
              value={maxAuditedLtv}
              setState={handleMaxAuditedLtv}
              error={maxAuditedLtvState}
              setError={setMaxAuditedLtvState}
              disabled={viewPage}
              setBlur={(e) => handleBlur(e, 'maxAudited')}
            />
          </Grid>
        </Grid>
      </Grid>
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}

      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

export default RiskCategoryScoreMasterCreate;
